import { createAction } from 'redux-actions';
import { PREFIX as ROOT_PREFIX } from '../actions';

export const fetchAuctionOrders = createAction(`${ROOT_PREFIX}/fetchAuctionOrders`, (region, locale) => ({ region, locale }));
export const setAuctionOrders = createAction(`${ROOT_PREFIX}/setAuctionOrders`);
